import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
import { Debug } from '@awayjs/core';
import { DefaultFontManager } from '@awayjs/scene';
var Font = /** @class */ (function (_super) {
    __extends(Font, _super);
    function Font() {
        var _this = _super.call(this) || this;
        _this.isAVMFont = true;
        _this.isAVMFont = true;
        if (_this.axClassName != 'Font') {
            _this._adaptee = DefaultFontManager.getFont(_this.axClassName);
        }
        return _this;
    }
    Object.defineProperty(Font.prototype, "fontName", {
        get: function () {
            var _a;
            return (_a = this._adaptee) === null || _a === void 0 ? void 0 : _a.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Font.prototype, "fontStyle", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/Font', 'get fontStyle', '');
            return 'regular';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Font.prototype, "fontType", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/Font', 'get fontType', '');
            return 'embedded';
        },
        enumerable: false,
        configurable: true
    });
    Font.enumerateFonts = function (enumerateDeviceFonts) {
        if (enumerateDeviceFonts === void 0) { enumerateDeviceFonts = false; }
        // @todo
        Debug.throwPIR('playerglobals/text/Font', 'enumerateFonts', '');
        return [];
    };
    Font.registerFont = function (font) {
        // this is not needed for AwayJS, because fonts are already registered after parsing
        //console.warn('`Font.registerFont` not implement yet');
    };
    Font.prototype.hasGlyphs = function (str) {
        // @todo
        Debug.throwPIR('playerglobals/text/Font', 'hasGlyphs', '');
        return false;
    };
    Font.forceNativeConstructor = true;
    Font.forceNativeMethods = true;
    Font.classInitializer = null;
    Font.classSymbols = null;
    Font.instanceSymbols = null;
    return Font;
}(ASObject));
export { Font };
